var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1973_36817)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EBEEF2",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 15.2695V19.4001C28 19.9601 28 20.2401 28.109 20.4541C28.2049 20.6422 28.3578 20.7952 28.546 20.8911C28.7599 21.0001 29.0399 21.0001 29.6 21.0001H33.7305M28 30H22M30 26H22M34 22.9882V30.2C34 31.8802 34 32.7202 33.673 33.362C33.3854 33.9265 32.9265 34.3854 32.362 34.673C31.7202 35 30.8802 35 29.2 35H22.8C21.1198 35 20.2798 35 19.638 34.673C19.0735 34.3854 18.6146 33.9265 18.327 33.362C18 32.7202 18 31.8802 18 30.2V19.8C18 18.1198 18 17.2798 18.327 16.638C18.6146 16.0735 19.0735 15.6146 19.638 15.327C20.2798 15 21.1198 15 22.8 15H26.0118C26.7455 15 27.1124 15 27.4577 15.0829C27.7638 15.1564 28.0564 15.2776 28.3249 15.4421C28.6276 15.6276 28.887 15.887 29.4059 16.4059L32.5941 19.5941C33.113 20.113 33.3724 20.3724 33.5579 20.6751C33.7224 20.9436 33.8436 21.2362 33.9171 21.5423C34 21.8876 34 22.2545 34 22.9882Z",
    stroke: "#475467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1973_36817",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1973_36817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1973_36817",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalNote);
export default __webpack_public_path__ + "static/media/modal-note.d96ccbad3bf8486f63cffc28346d162d.svg";
export { ForwardRef as ReactComponent };